import React, { useState } from 'react';

function Consent() {
  const [isChecked, setIsChecked] = useState(() => {
    const consent = localStorage.getItem('consent');
    return consent === "Yes";
  });

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
    localStorage.setItem('consent', isChecked ? "No" : "Yes");
  };

  return (
    <div>
      <div className="mt-4">
        <label htmlFor="terms" className="block font-medium text-gray-700 bg-green-100 py-2 px-3 rounded-md">
          <input
            type="checkbox"
            name="terms"
            checked={isChecked}
            onChange={handleCheckboxChange}
            className="mr-2 leading-tight"
          />
          I Consent to receive Email and phone call updates about the Conference
        </label>
      </div>
    </div>
  );
}

export default Consent;
